



















import {Component, Prop, PropSync, Vue, Emit} from 'vue-property-decorator'

@Component({
  name: 'ElementTabs',
  components: {
  }
})
export default class extends Vue {

  @PropSync('tabKey', {default: ''}) syncTabKey!: string;
  @Prop({required: true}) tabsArray!: Array<any>;
  @Prop({default: ''}) cssClass!: string;
  @Prop({default: null}) tabsType!: 'border-card' | 'card' | null;

  created() {
  }

  @Emit('tab-click')
  tabClick() {
    return this.syncTabKey
  }

  private handleClick() {
    this.$emit('update:syncTabKey', this.syncTabKey);
    this.tabClick();

  }

}
